import React from 'react';
import AnimatedMessage from './AnimatedMessage';
import { Icon, IconButton } from '@blend-ed/blendx-ui';
import { getConfig } from '@edx/frontend-platform';
import { injectIntl, intlShape } from '@edx/frontend-platform/i18n';
import PropTypes from 'prop-types';
import useIframeContentProcessor from '../../../../hooks/useIframeContentProcessor';
const MessageBubble = ({ message, intl, onExpandView, isLastMessage, isNewMessage, handleLearnerLearningPath }) => {

  const { type, content, contentType = 'text', createdAt, generatedLearningPath } = message;

  if (contentType === 'text') {
    return (
      <div className={`message-bubble ${type}`}>
        <div className="message-content">
          {type === 'ai' ? (
            <AnimatedMessage
              content={content}
              isLastMessage={isLastMessage}
              isNewMessage={isNewMessage}
            />
          ) : (
            <p>{content}</p>
          )}
        </div>
      </div>
    );
  }

  if (contentType === 'xblock') {
    const iframeUrl = `${getConfig().LMS_BASE_URL}/xblock/${content.blockId}?show_title=0&show_bookmark=0&recheck_access=1&view=student_view&auto_height=true`;
    const { contentHeight } = useIframeContentProcessor(iframeUrl);
    return (
      <div className={`message-bubble ${type} full-width`}>
        <div className="message-content xblock-content">
          <div className="xblock-header">
            <div className="xblock-title-container">
              <div className="xblock-title">
                {content.title.split(' > ')[content.title.split(' > ').length - 1]}
                <span className="xblock-subtitle">{generatedLearningPath.length > 1 ? `(${generatedLearningPath.length} units)` : ''}</span>
              </div>
              <div className="xblock-subtitle">{content.title}</div>
            </div>
            <IconButton
              icon="expand-diagonal"
              iconType="line"
              variant="ghost-gray"
              size="xs"
              className="xblock-expand-button"
              onClick={() => {
                onExpandView(true)
                handleLearnerLearningPath(generatedLearningPath)
              }}
            />
          </div>
          <div className="xblock-iframe-container">
            <iframe
              title={content.title}
              src={iframeUrl}
              allow="microphone *; camera *; midi *; geolocation *; encrypted-media *, clipboard-write *"
              allowFullScreen
              style={{
                width: '100%',
                height: contentHeight ? contentHeight : '10rem',
                border: 'none',
                overflow: 'visible',
                marginTop: '-1rem'
              }}
              scrolling="no"
              referrerPolicy="origin"
              className="xblock-iframe"
            />
          </div>
        </div>
      </div>
    );
  }

  return null;
};

MessageBubble.propTypes = {
  message: PropTypes.shape({
    type: PropTypes.string.isRequired,
    content: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        blockId: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        lastAccessed: PropTypes.string.isRequired,
      }),
    ]).isRequired,
    contentType: PropTypes.string,
    createdAt: PropTypes.string.isRequired,
  }).isRequired,
  intl: intlShape.isRequired,
  onExpandView: PropTypes.func,
  isLastMessage: PropTypes.bool,
  isNewMessage: PropTypes.bool,
};

MessageBubble.defaultProps = {
  isLastMessage: false,
  isNewMessage: false,
};

export default injectIntl(MessageBubble); 